module.exports = __webpack_public_path__ + "static/logo-3890a1d0e57d6f059cf3e97bb238a3f3.png";